import React from 'react';
import { Box, Link, Paper, Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { ReleaseForm } from 'types/interfaces/medicalRecords';
import { getSignedUrl } from 'services/storageService';
import { logger } from 'services/logger';
import { AxiosError } from 'axios';

export function MedicalRecordRow(row: ReleaseForm) {
  const handleDownload = async (docUrl: string, fileName: string) => {
    if (!docUrl) return;
    try {
      const url = await getSignedUrl(docUrl, 'medical-record');
      const link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}_medical_record.pdf`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      logger.error('Error fetching signed hipaa waiver URL', {
        error: (error as AxiosError).message,
      });
    }
  };

  if (row.medicalRecords.length === 0) {
    return (
      <Box p={3} textAlign="center">
        <Typography variant="body1">No medical records available</Typography>
      </Box>
    );
  }
  return (
    <Box p={1} width={900}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableBody>
            {row.medicalRecords.map((item) => (
              <TableRow key={`record-${item.id}`}>
                <TableCell>{item.fileName}</TableCell>
                <TableCell>
                  <Link
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDownload(item.docUrl, item.fileName);
                    }}
                  >
                    Download
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
